(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mcb-books-description"] && !Shopify.designMode) return;
  try {
    
jQuery(function($){
    if($(".fits-in-the-series").length > 0) {
      $(".fits-in-the-series td").each(function(){
        $(this).wrapInner("<div class='select-in-series'></div>");
      });
    }
    $(".select-in-series").on('click', function(){
      if($(this).hasClass("active")) {
        $(this).removeClass("active");
      } else {
        $(".select-in-series").removeClass("active");
        $(this).addClass("active");
      }
    });
    if($(".fqpg_question").length > 0) {
      $(".fqpg_question").each(function(ind){
        if(ind == 0) {
          //$(this).addClass("active");
          $(this).trigger("click");
        }
      });
    }
    if($(".who-its-for").length > 0) {
      $(".who-its-for table td").each(function() {
          const $h2 = $(this).find("h2.process-title");

          if ($h2.length) {
              const text = $(this).contents().filter(function() {
                  return this.nodeType === 3 && this.textContent.trim() !== "";
              }).text().trim();

              if (text) {
                  $(this).contents().filter(function() {
                      return this.nodeType === 3;
                  }).remove();

                  $h2.after(`<div class="us-cp-dsc-cl"><p class="format-text">${text}</p></div>`);
              }
          }
      });
    }

  $(".fqpg_right_inner h3").each(function () {
    $(this).replaceWith(
      `<div class="fqpg_question" data-id="faq_FQ4Cfm" itemprop="name">${$(this).html()}</div>`
    );
  });

  $(".fqpg_right_inner .fqpg_question").each(function () {
      $(this).nextUntil(".fqpg_question").wrapAll(
          '<div class="fqpg_answer" style="display:none; overflow:hidden;" data-id="faq_FQ4Cfm" itemprop="acceptedAnswer" itemscope itemtype="https://schema.org/Answer"></div>'
      );
  });

  $(".fqpg_right_inner .fqpg_question").each(function () {
      $(this)
          .next(".fqpg_answer")
          .andSelf() // use addBack() if using jQuery 1.8+
          .wrapAll('<div class="fqpg_faq_item" itemscope itemprop="mainEntity" itemtype="https://schema.org/Question"></div>');
  });
});

  } catch(e) { console.error(e); }
})();
})();
